import React from "react";
// import { accesRsole } from "../helpers/access_role"
import { Redirect } from "react-router-dom";

import { default as MasterRole } from "../pages/Master/Role/RouteView";
import { default as Sample } from "../pages/Sample/RouteView";

import { default as KepegawaianHome } from "../pages/Kepegawaian/RouteView";
import { default as DUK } from "../pages/Kepegawaian/DUK/RouteView";
import { default as IP } from "../pages/Kepegawaian/IndeksProfessionalitas/RouteView";
import { default as PencatumanGelar } from "../pages/Kepegawaian/PencantumanGelar/RouteView";
import { default as KenaikanPangkat } from "../pages/Kepegawaian/KenaikanPangkat/RouteView";
import { default as MasterGaji } from "../pages/Master/GajiPokok/RouteView";
import { default as MasterGajiP3K } from "../pages/Master/GajiPokokP3K/RouteView";
import { default as KGB } from "../pages/Kepegawaian/KGB/RouteView";
import { default as CPNS } from "../pages/Kepegawaian/CPNS/RouteView";
// import { default as DokumenCPNS } from "../pages/Kepegawaian/DokumenCPNS/RouteView";
import { default as PengangkatanPNS } from "../pages/Kepegawaian/PengangkatanPNS/RouteView";
import { default as DokumenPengangkatanPNS } from "../pages/Kepegawaian/DokumenPengangkatanPNS/RouteView";
import { default as P3K } from "../pages/Kepegawaian/P3K/RouteView";
import { default as PengangkatanP3K } from "../pages/Kepegawaian/PengangkatanP3K/RouteView";
import { default as DokumenPengangkatanP3K } from "../pages/Kepegawaian/DokumenPengangkatanP3K/RouteView";
import { default as Flexyport } from "../pages/Kepegawaian/Flexyport/RouteView";
import { default as SKP } from "../pages/Kepegawaian/SKP/RouteView";
import { default as Verification } from "../pages/Kepegawaian/Verification/RouteView";
import { default as HukumanDisiplin } from "../pages/Kepegawaian/HukumanDisiplin/RouteView";
import { default as Hukdis } from "../pages/Kepegawaian/Hukdis/RouteView";
import { default as FilePersiapanPensiun } from "../pages/Kepegawaian/FilePersiapanPensiun/RouteView";
import { default as MasterFlexytime } from "../pages/Master/Flexytime/RouteView";
import { default as MasterPolaKerja } from "../pages/Master/PolaKerja/RouteView";
import { default as MasterExcludeAbsen } from "../pages/Master/ExcludeAbsen/RouteView";
import { default as MasterPemutihanAbsen } from "../pages/Master/PemutihanAbsen/RouteView";
import { default as VerifikasiKehadiran } from "../pages/Kepegawaian/VerifikasiKehadiran/RouteView";
import { default as VerifikasiPembatalan } from "../pages/Kepegawaian/VerifikasiPembatalan/RouteView";
import { default as MasterPolaKerjaPegawai } from "../pages/Master/PolaKerjaPegawai/RouteView";
import { default as MasterPeriodeVerifikasi } from "../pages/Master/PeriodeVerifikasi/RouteView";

import { default as PengajuanWFH } from "../pages/Kepegawaian/PengajuanWFH/RouteView";
import { default as PengajuanAngkaKredit } from "../pages/Kepegawaian/PengajuanAngkaKredit/RouteView";
// import { default as Calendar } from '../pages/Kepegawaian/Calendar/RouteView'

import { default as KepegawaianRevisiKeuangan } from "../pages/Kepegawaian/RevisiKeuangan/RouteView";
import { default as KepegawaianLaporanPenilaianSKP } from "../pages/Kepegawaian/LaporanPenilaianSKP/RouteView";
import { default as RekapAbsensi } from "../pages/Kepegawaian/RekapAbsensi/RouteView";
import { default as Penilaian360 } from "../pages/Kepegawaian/Penilaian360/RouteView";
import { default as Lembur } from "../pages/Kepegawaian/Lembur/RouteView";

import WelcomeScreen from "../pages/Home/Dashboard/ViewWelcome";
import Dashboard from "../pages/Home/Dashboard/View";
// import Dashboard from "../pages/Home/Dashboard/Sample/index"
import HomeProfile from "../pages/Home/Profile/RouteView";
import HomeNotification from "../pages/Home/Notification/RouteView";

//presensi
import { default as KepegawaianPresensi } from "../pages/Kepegawaian/PresensiAdmin/RouteView";
import { default as IntegrasiSimpegBkn } from "../pages/Kepegawaian/IntegrasiSimpegBkn/RouteView";
import { default as IntegrasiBknSimpeg } from "../pages/Kepegawaian/IntegrasiSimpegBkn/RouteView";
import { default as IntegrasiSimpegBknMutasi } from "../pages/Kepegawaian/IntegrasSimpegBknMutasi/RouteView";
import { default as IntegrasiSimpegBknDiklat } from "../pages/Kepegawaian/IntegrasiSimpegBknDiklat/RouteView";

//Tunjangan Kinerja
import { default as KepegawaianTunjangankinerja } from "../pages/Kepegawaian/Tunjangankinerja/RouteView";

// Uang Makan
import { default as KepegawaianUangmakan } from "../pages/Kepegawaian/Uangmakan/RouteView";

// Honorarium
import { default as KepegawaianHonorarium } from "../pages/Kepegawaian/Honorarium/RouteView";

// Route Roby
import { default as PengaturanMenu } from "../pages/Pengaturan/Menu/RouteView";
import { default as PengaturanAkses } from "../pages/Pengaturan/Akses/RouteView";
import { default as PengaturanCron } from "../pages/Pengaturan/Cron/RouteView";
import { default as MasterStrukturOrganisasi } from "../pages/Master/StrukturOrganisasi/RouteView";
import { default as MasterAgama } from "../pages/Master/Agama/RouteView";
import { default as MasterGolongan } from "../pages/Master/Golongan/RouteView";
import { default as MasterPangkat } from "../pages/Master/Pangkat/RouteView";
import { default as MasterPangkatP3K } from "../pages/Master/PangkatP3K/RouteView";
import { default as PetaJabatan } from "../pages/Kepegawaian/PetaJabatan/RouteView";
import { default as IzinCuti } from "../pages/Kepegawaian/IzinPegawai/Cuti/RouteView";
import { default as IzinDinas } from "../pages/Kepegawaian/IzinPegawai/Dinas/RouteView";
import { default as IzinTanpaKeterangan } from "../pages/Kepegawaian/IzinPegawai/TanpaKeterangan/RouteView";
import { default as IzinKoreksiKehadiran } from "../pages/Kepegawaian/IzinPegawai/KoreksiKehadiran/RouteView";
import { default as PemberianPenghargaan } from "../pages/Kepegawaian/PemberianPenghargaan/RouteView";
import { default as MasterJenisDiklat } from "../pages/Master/JenisDiklat/RouteView";
import { default as LevelTunjanganKhusus } from "../pages/Master/LevelTunjanganKhusus/RouteView";
import { default as MasterScheduler } from "../pages/Master/Scheduler/RouteView";
import { default as KomponenPenilaian } from "../pages/Master/KomponenPenilaian/Komponen/RouteView";
import { default as BobotKomponenPenilaian } from "../pages/Master/KomponenPenilaian/BobotKomponenPenilaian/RouteView";
import { default as BobotPenilaianIndividu } from "../pages/Master/KomponenPenilaian/BobotPenilaianIndividu/RouteView";
import { default as BobotTunjanganKhusus } from "../pages/Master/KomponenPenilaian/BobotTunjanganKhusus/RouteView";
import { default as MasterMappingBkn } from "../pages/Master/MappingBkn/RouteView";
import { default as PositionBkn } from "../pages/Master/JabatanBkn/RouteView";
import { default as PengecualianPenghargaan } from "../pages/Master/PengecualianPenghargaan/RouteView";
import { default as MutasiPegawai } from "../pages/Kepegawaian/MutasiPegawai/RouteView";
import { default as MutasiBaru } from "../pages/Kepegawaian/MutasiBaru/RouteView";
import { default as MutasiPPI } from "../pages/Kepegawaian/MutasiPPI/RouteView";
import { default as PengajuanDokumen } from "../pages/Kepegawaian/PengajuanDokumen/RouteView";
import { default as MasterJabatan } from "../pages/Master/Jabatan/RouteView";
import { default as DokumenPensiun } from "../pages/Master/DokumenPensiun/RouteView";

//refSIASIN
import { default as RefSIASINJabatanfungsionalUmum } from "../pages/Master/RefSIASIN/JabatanfungsionalUmum/RouteView";
import { default as RefSIASINJabatanfungsionalTertentu } from "../pages/Master/RefSIASIN/JabatanfungsionalTertentu/RouteView";
import { default as RefSIASINJabatanStruktural } from "../pages/Master/RefSIASIN/JabatanStruktural/RouteView";

//refMesinAbsen
import { default as RefMesinAbsenUserInfo } from "../pages/Master/RefMesinAbsen/UserInfo/RouteView";
import { default as RefMesinAbsenMappingPegawai } from "../pages/Master/RefMesinAbsen/MappingPegawai/RouteView";

//*ROUTE RUDI
import { default as Acmanajerial } from "../pages/Master/Ac_manajerial/RouteView";
import { default as Acteknis } from "../pages/Master/Ac_teknis/RouteView";
import { default as Acsosiokultural } from "../pages/Master/Ac_sosiokultural/RouteView";
import { default as StandarKompetensi } from "../pages/Master/StandarKompetensi/RouteView";
import { default as SyaratJabatan } from "../pages/Master/Syaratjabatan/RouteView";
//*Assesment
import { default as AssesmentManajerial } from "../pages/Assesment/Managerial/RouteView";
import { default as AssesmentSosiocultural } from "../pages/Assesment/Sosiocultural/RouteView";
import { default as AssesmentTeknis } from "../pages/Assesment/Teknis/RouteView";
//*Laporan
import { default as manajemenTalenta } from "../pages/Laporan/Manajementalenta/RouteView";
import { default as JPM } from "../pages/Laporan/jpm/RouteView";
import { default as LaporanPresensi } from "../pages/Laporan/presensi/RouteView";
import { default as LaporanMasakerja } from "../pages/Laporan/masakerja/RouteView";
import { default as LaporanPensiun } from "../pages/Laporan/pensiun/RouteView";
import { default as LaporanWFH } from "../pages/Laporan/wfh/RouteView";
//*Master Presensi
import { default as Hollyday } from "../pages/Master/Hollyday/RouteView";
import { default as LocationPresence } from "../pages/Master/LocationPresence/RouteView";
import { default as CuttingCategory } from "../pages/Master/Potongan_tunkin/RouteView";
//rekap ketidakhadiran
import { default as RekapKetidakhadiran } from "../pages/Kepegawaian/RekapKetidakhadiran/RouteView";
//Pejabat Penetap
import { default as MasterPejabatPenetap } from "../pages/Master/PejabatPenetap/RouteView";
//Wilayah
import { default as MasterProvinsi } from "../pages/Master/Provinsi/RouteView";
import { default as MasterKota } from "../pages/Master/Kota/RouteView";

// IMPORT SANDY
import { default as MasterBank } from "../pages/Master/Bank/RouteView";
import { default as MasterTemplateSurat } from "../pages/Master/TemplateSurat/RouteView";
import { default as MasterRumpun } from "../pages/Master/Rumpun/RouteView";

import { default as MasterPunishment } from "../pages/Master/Punishment/RouteView";
import { default as Pensiun } from "../pages/Kepegawaian/Pensiun/RouteView";
import { default as PensiunSK } from "../pages/Kepegawaian/PensiunSK/RouteView";
import { default as Hukuman } from "../pages/Kepegawaian/Hukuman/RouteView";
import { default as DokumenPelantikan } from "../pages/Kepegawaian/DokumenPelantikan/RouteView";
import { default as UndanganPelantikan } from "../pages/Kepegawaian/UndanganPelantikan/RouteView";
import { default as RiwayatAngkakredit } from "../pages/Kepegawaian/RiwayatAngkaKredit/Admin/RouteView";
import { default as MasterJenjangPendidikan } from "../pages/Master/JenjangPendidikan/RouteView";

import { default as DMS } from "../pages/DMS/RouteView";

import { default as DiklatStruktural } from "../pages/Kepegawaian/Diklat/Admin/struktural/RouteView";
import { default as DiklatFungsional } from "../pages/Kepegawaian/Diklat/Admin/fungsional/RouteView";
import { default as DiklatTeknis } from "../pages/Kepegawaian/Diklat/Admin/teknis/RouteView";
import { default as DiklatSertifikasi } from "../pages/Kepegawaian/Skillcertification/Admin/RouteView";
import { default as DiklatKursus } from "../pages/Kepegawaian/Seminar/Admin/RouteView";

import { default as MonitoringLembur } from "../pages/Kepegawaian/MonitoringLembur/RouteView";

// Verifikasi Penilaian Tunjangan Khusus
import { default as VerifikasiTunsus } from "../pages/Kepegawaian/VerifikasiTunjanganKhusus/RouteView";
import { default as PenilaianTunsus } from "../pages/Kepegawaian/PenilaianTunjanganKhusus/RouteView";
import { default as SkpTunsus } from "../pages/Kepegawaian/SKPTunjanganKhusus/RouteView";
import { default as SKPBaru } from "../pages/Kepegawaian/SKPBaru/RouteView";
import { default as MappingKelasPegawai } from "../pages/Kepegawaian/MappingKelasPegawai/RouteView";
import { default as RevisiTunjangankhusus } from "../pages/Kepegawaian/RevisiTunjanganKhusus/RouteView";

// import { default as PenilaianTunjanganKhusus } from "../pages/Kepegawaian/PenilaianTunjanganKhusus/RouteView";
import { default as MappingMasaKerja } from "../pages/Kepegawaian/MappingMasaKerja/RouteView";

// Pemadanan Data
import { default as Legal } from "../pages/Master/Legal/RouteView";
import { default as EmployeeStatus } from "../pages/Master/EmployeeStatus/RouteView";
import { default as Dependent } from "../pages/Master/Dependent/RouteView";
//tambahan rudi
import { default as ConfigTunjangan } from "../pages/Master/ConfigTunjangan/RouteView";
import { default as KriteriaSkpTunkin } from "../pages/Master/KriteriaSkpTunkin/RouteView";
import { default as KriteriaSkpTunsus } from "../pages/Master/KriteriaSkpTunsus/RouteView";
import { default as PemadananData } from "../pages/Kepegawaian/Pemadanan/RouteView";

//Tambahan Route
import { default as StukturOrganisasi } from "../pages/Kepegawaian/StrukturOrganisasi/RouteView";

// Master Penilaian 360
import { default as BankSoal360 } from "../pages/Master/Penilaian360/BankSoal/RouteView";
import { default as JenisJabatan360 } from "../pages/Master/Penilaian360/JenisJabatan/RouteView";
import { default as Perhitungan360 } from "../pages/Master/Penilaian360/Perhitungan/RouteView";
import { default as Team360 } from "../pages/Master/Penilaian360/Team/RouteView";
import { default as UnitKerja360 } from "../pages/Master/Penilaian360/UnitKerja/RouteView";
import { default as BagianSoal360 } from "../pages/Master/Penilaian360/BagianSoal/RouteView";
import { default as Kompetensi360 } from "../pages/Master/Penilaian360/Kompetensi/RouteView";

// Assesment Penilaian 360
import { default as PenilaianPegawai360 } from "../pages/Assesment/Penilaian360/Penilaian/RouteView";


import Logout from "../pages/Authentication/Logout";

const userRoutes = [
  {
    path: "/",
    exact: true,
    component: () => {
      // if (parseInt(localStorage.getItem('currentRoleId')) === 1){ // jika admin
      //   return <Redirect to="/home/dashboard.html" />
      // } else { // selain admin
      //   return <Redirect to="/home/profile.html" />
      // }
      return <WelcomeScreen />;
    },
  },
  {
    path: "/home/dashboard.html",
    component: () => {
      // if (parseInt(localStorage.getItem('currentRoleId')) === 1){ // jika admin
      //   return <WelcomeScreen/>
      // } else {
      //   return <Redirect to="/home/profile.html" />
      // }
      return <WelcomeScreen />;
    },
  },
  { path: "/home/profile.html", component: HomeProfile },
  { path: "/home/notification.html", component: HomeNotification },

  { path: "/sample.html", component: Sample },
  { path: "/kepegawaian/home.html", component: KepegawaianHome },
  { path: "/kepegawaian/duk.html", component: DUK },
  { path: "/kepegawaian/indeks_professionalitas.html", component: IP },
  { path: "/kepegawaian/pencantuman_gelar.html", component: PencatumanGelar },
  { path: "/kepegawaian/kenaikan_pangkat.html", component: KenaikanPangkat },
  { path: "/kepegawaian/kgb.html", component: KGB },
  { path: "/kepegawaian/cpns.html", component: CPNS },
  // { path: "/kepegawaian/docummen_cpns.html", component: DokumenCPNS },

  { path: "/kepegawaian/dokumen_pns.html", component: DokumenPengangkatanPNS },
  { path: "/kepegawaian/pns.html", component: PengangkatanPNS },
  { path: "/kepegawaian/cp3k.html", component: P3K },
  { path: "/kepegawaian/p3k.html", component: PengangkatanP3K },
  {
    path: "/kepegawaian/dokumen_pengangkatan_pppk.html",
    component: DokumenPengangkatanP3K,
  },
  { path: "/kepegawaian/flexyport.html", component: Flexyport },
  // { path: "/kepegawaian/skp.html", component: SKP },
  { path: "/kepegawaian/verification.html", component: Verification },
  // { path: "/kepegawaian/hukuman_disiplin.html", component: HukumanDisiplin },
  { path: "/kepegawaian/hukuman_disiplin.html", component: Hukdis },
  {
    path: "/kepegawaian/file_persiapan_pensiun.html",
    component: FilePersiapanPensiun,
  },
  { path: "/master/flexytime.html", component: MasterFlexytime },
  { path: "/master/pola_kerja.html", component: MasterPolaKerja },
  { path: "/master/exclude_absen.html", component: MasterExcludeAbsen },
  { path: "/master/pemutihan.html", component: MasterPemutihanAbsen },
  {
    path: "/master/pola_kerja_pegawai.html",
    component: MasterPolaKerjaPegawai,
  },
  {
    path: "/master/periode_verifikasi.html",
    component: MasterPeriodeVerifikasi,
  },
  { path: "/kepegawaian/rekap_absensi.html", component: RekapAbsensi },
  { path: "/kepegawaian/rekap360.html", component: Penilaian360 },
  {
    path: "/kepegawaian/verifikasi_pembatalan.html",
    component: VerifikasiPembatalan,
  },
  {
    path: "/kepegawaian/verifikasi_kehadiran.html",
    component: VerifikasiKehadiran,
  },
  { path: "/kepegawaian/pengajuan_wfh.html", component: PengajuanWFH },
  { path: "/kepegawaian/lembur.html", component: Lembur },
  { path: "/kepegawaian/monitoring_lembur.html", component: MonitoringLembur },
  {
    path: "/kepegawaian/pengajuan_angka_kredit.html",
    component: PengajuanAngkaKredit,
  },

  // { path: "/kepegawaian/calendar.html", component: Calendar },

  { path: "/setting/menu.html", component: PengaturanMenu },
  { path: "/setting/accesses.html", component: PengaturanAkses },
  { path: "/setting/cron.html", component: PengaturanCron },

  { path: "/master/role.html", component: MasterRole },
  {
    path: "/master/struktur-organisasi.html",
    component: MasterStrukturOrganisasi,
  },
  { path: "/master/bank.html", component: MasterBank },
  { path: "/master/template-surat.html", component: MasterTemplateSurat },
  { path: "/master/rumpun.html", component: MasterRumpun },

  {
    path: "/master/jenjang_pendidikan.html",
    component: MasterJenjangPendidikan,
  },

  { path: "/master/punishment.html", component: MasterPunishment },

  { path: "/master/agama.html", component: MasterAgama },
  { path: "/master/golongan.html", component: MasterGolongan },
  { path: "/master/pangkat.html", component: MasterPangkat },
  { path: "/master/pangkat_pppk.html", component: MasterPangkatP3K },
  { path: "/master/gaji_pokok.html", component: MasterGaji },
  { path: "/master/gaji_pokok_pppk.html", component: MasterGajiP3K },
  { path: "/kepegawaian/pensiun.html", component: Pensiun },
  { path: "/kepegawaian/hukuman.html", component: Hukuman },
  { path: "/kepegawaian/pensiunsk.html", component: PensiunSK },

  //presensi
  { path: "/kepegawaian/presensi.html", component: KepegawaianPresensi },

  {
    path: "/kepegawaian/revisi_keuangan.html",
    component: KepegawaianRevisiKeuangan,
  },
  {
    path: "/kepegawaian/laporan_penilaian_skp.html",
    component: KepegawaianLaporanPenilaianSKP,
  },

  //tunjangan kinerja
  {
    path: "/kepegawaian/tunjangankinerja.html",
    component: KepegawaianTunjangankinerja,
  },

  //uang makan
  { path: "/kepegawaian/uangmakan.html", component: KepegawaianUangmakan },

  //honorarium
  { path: "/kepegawaian/honorarium.html", component: KepegawaianHonorarium },

  //rudi
  { path: "/kamuskompetensi/manajerial.html", component: Acmanajerial },
  { path: "/kamuskompetensi/teknis.html", component: Acteknis },
  { path: "/kamuskompetensi/sosiokultural.html", component: Acsosiokultural },
  { path: "/master/standar_kompetensi.html", component: StandarKompetensi },
  { path: "/master/syarat_jabatan.html", component: SyaratJabatan },
  { path: "/assesment/manajerial.html", component: AssesmentManajerial },
  { path: "/assesment/teknis.html", component: AssesmentTeknis },
  { path: "/assesment/sosiocultural.html", component: AssesmentSosiocultural },
  { path: "/laporan/manajementalenta.html", component: manajemenTalenta },
  { path: "/laporan/jpm.html", component: JPM },
  { path: "/laporan/laporan_presensi.html", component: LaporanPresensi },
  { path: "/laporan/laporan_masakerja.html", component: LaporanMasakerja },
  { path: "/laporan/laporan_pensiun.html", component: LaporanPensiun },
  { path: "/laporan/laporan_wfh.html", component: LaporanWFH },
  { path: "/master/config_tunjangan.html", component: ConfigTunjangan },
  { path: "/master/kriteria_skp_tunkin.html", component: KriteriaSkpTunkin },
  { path: "/master/kriteria_skp_tunsus.html", component: KriteriaSkpTunsus },

  { path: "/master/hari_libur.html", component: Hollyday },
  { path: "/master/presensi_lokasi.html", component: LocationPresence },
  { path: "/master/potongan_tunkin.html", component: CuttingCategory },
  { path: "/master/pejabat_penetap.html", component: MasterPejabatPenetap },
  { path: "/master/provinsi.html", component: MasterProvinsi },
  { path: "/master/kota.html", component: MasterKota },

  {
    path: "/kepegawaian/rekap_ketidakhadiran.html",
    component: RekapKetidakhadiran,
  },

  { path: "/kepegawaian/petajabatan.html", component: PetaJabatan },

  { path: "/izinpegawai/cuti.html", component: IzinCuti },
  { path: "/izinpegawai/dinas.html", component: IzinDinas },
  {
    path: "/izinpegawai/ketidakhadirantanpaketerangan.html",
    component: IzinTanpaKeterangan,
  },
  {
    path: "/izinpegawai/koreksikehadiran.html",
    component: IzinKoreksiKehadiran,
  },

  {
    path: "/kepegawaian/pemberian_penghargaan.html",
    component: PemberianPenghargaan,
  },
  {
    path: "/master/komponen_penilaian_komponen.html",
    component: KomponenPenilaian,
  },
  {
    path: "/master/komponen_penilaian_bobot_komponen_penilaian.html",
    component: BobotKomponenPenilaian,
  },
  {
    path: "/master/komponen_penilaian_bobot_tunjangan_khusus.html",
    component: BobotTunjanganKhusus,
  },
  {
    path: "/master/komponen_penilaian_bobot_penilaian_individu.html",
    component: BobotPenilaianIndividu,
  },

  { path: "/master/scheduler.html", component: MasterScheduler },
  { path: "/master/jenis-diklat.html", component: MasterJenisDiklat },
  {
    path: "/master/level_tunjangan_khusus.html",
    component: LevelTunjanganKhusus,
  },
  { path: "/master/mapping-jabatan-bkn.html", component: MasterMappingBkn },
  { path: "/master/jabatan_bkn.html", component: PositionBkn },
  {
    path: "/master/pengecualian_penghargaan.html",
    component: PengecualianPenghargaan,
  },
  { path: "/kepegawaian/mutasi_pegawai.html", component: MutasiPegawai },
  { path: "/kepegawaian/mutasi_baru.html", component: MutasiBaru },
  { path: "/kepegawaian/mutasi_tpln.html", component: MutasiPPI },
  // { path: "/kepegawaian/mutasi_tpln.html", component: MutasiPegawai },
  { path: "/kepegawaian/daftar_mutasi_tpln.html", component: MutasiPPI },
  // { path: "/kepegawaian/daftar_mutasi_tpln.html", component: MutasiPegawai },
  { path: "/kepegawaian/pengajuan_dokumen.html", component: PengajuanDokumen },
  {
    path: "/kepegawaian/integrasi_simpeg_bkn.html",
    component: IntegrasiSimpegBkn,
  },
  {
    path: "/kepegawaian/integrasi_bkn_simpeg.html",
    component: IntegrasiSimpegBkn,
  },
  {
    path: "/kepegawaian/integrasi_mutasi_simpeg_bkn.html",
    component: IntegrasiSimpegBknMutasi,
  },
  {
    path: "/kepegawaian/integrasi_diklat_simpeg_bkn.html",
    component: IntegrasiSimpegBknDiklat,
  },

  { path: "/master/position.html", component: MasterJabatan },
  { path: "/master/dokumen_pensiun.html", component: DokumenPensiun },

  //refSIASIN
  {
    path: "/master/ref_bkn_jabatan_umum.html",
    component: RefSIASINJabatanfungsionalUmum,
  },
  {
    path: "/master/ref_bkn_jabatan_tertentu.html",
    component: RefSIASINJabatanfungsionalTertentu,
  },
  {
    path: "/master/ref_bkn_jabatan_struktural.html",
    component: RefSIASINJabatanStruktural,
  },

  //refMesinAbsen
  {
    path: "/master/ref_mesin_absen_mapping_pegawai.html",
    component: RefMesinAbsenMappingPegawai,
  },
  {
    path: "/master/ref_mesin_absen_user_info.html",
    component: RefMesinAbsenUserInfo,
  },

  { path: "/dms.html", component: DMS },

  {
    path: "/kepegawaian/dokumen_pelantikan.html",
    component: DokumenPelantikan,
  },
  {
    path: "/kepegawaian/undangan_pelantikan.html",
    component: UndanganPelantikan,
  },
  {
    path: "/kepegawaian/riwayat_angkakredit.html",
    component: RiwayatAngkakredit,
  },
  { path: "/kepegawaian/diklat/struktural.html", component: DiklatStruktural },
  { path: "/kepegawaian/diklat/fungsional.html", component: DiklatFungsional },
  { path: "/kepegawaian/diklat/teknis.html", component: DiklatTeknis },
  { path: "/kepegawaian/diklat/kursus.html", component: DiklatKursus },
  {
    path: "/kepegawaian/diklat/skillcertification.html",
    component: DiklatSertifikasi,
  },
  {
    path: "/kepegawaian/verifikasi_tunjangan_khusus.html",
    component: VerifikasiTunsus,
  },
  {
    path: "/kepegawaian/penilaian_tunjangan_khusus.html",
    component: PenilaianTunsus,
  },

  {
    path: "/kepegawaian/skp_tunjangan_khusus.html",
    component: SkpTunsus,
  },
  {
    path: "/kepegawaian/skp.html",
    component: SKPBaru,
  },

  {
    path: "/kepegawaian/mapping_tunjangan_khusus.html",
    component: MappingKelasPegawai,
  },

  {
    path: "/kepegawaian/revisi_tunjangan_khusus.html",
    component: RevisiTunjangankhusus,
  },
  {
    path: "/kepegawaian/mapping_masa_kerja.html",
    component: MappingMasaKerja,
  },
  {
    path: "/kepegawaian/pemadanan.html",
    component: PemadananData,
  },

  // Pemadanan
  { path: "/master/kedudukan_hukum.html", component: Legal },
  { path: "/master/status_pegawai.html", component: EmployeeStatus },
  { path: "/master/kode_kawin.html", component: Dependent },
  { path: "/master/pendidikan.html", component: MasterJenjangPendidikan },
  { path: "/master/jabatan.html", component: MasterJabatan },

  //Tambahan
  {
    path: "/kepegawaian/strukturorganisasi.html",
    component: StukturOrganisasi,
  },

  // Master Penilaian 360
  { path: "/master/banksoal360.html", component: BankSoal360 },
  { path: "/master/jenisjabatan360.html", component: JenisJabatan360 },
  { path: "/master/perhitungan360.html", component: Perhitungan360 },
  { path: "/master/timkerja360.html", component: Team360 },
  { path: "/master/unitkerja360.html", component: UnitKerja360 },
  { path: "/master/bagiansoal360.html", component: BagianSoal360 },
  { path: "/master/bagian_soal360.html", component: BagianSoal360 },
  { path: "/master/kompetensi360.html", component: Kompetensi360 },
  { path: "/master/kompentensi360.html", component: Kompetensi360 },

  // Penilaian 360
  { path: "/kepegawaian/penialian360.html", component: PenilaianPegawai360 },


];

const authRoutes = [
  { path: "/logout.html", component: Logout },
  { path: "/dashboard.html", component: Dashboard },
];

export { userRoutes, authRoutes };
